import React, { useEffect, useState } from 'react';
import logo from '../../images/logo.png';
import '../Profile/Profile.css';
import { Link as Anchor, useParams } from 'react-router-dom';
import baseURL from '../url';
import { InstagramIcon, FacebookIcon, WhatsAppIcon, TikTokIcon } from '../SocialIcons/SocialIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export default function ProfileTienda({ onClose }) {
    const [tienda, setTienda] = useState(null);
    const { idTienda } = useParams();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        cargarTiendas();

        const handleTiendaCargada = (e) => {
            if (e.detail) {
                setTienda(e.detail);
                setLoading(false);
            }
        };
        window.addEventListener('tienda-cargada', handleTiendaCargada);
        return () => window.removeEventListener('tienda-cargada', handleTiendaCargada);
    }, [idTienda]);

    const cargarTiendas = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (idTienda) {
                    const tiendaEncontrada = data?.tiendas?.find(t => t.idTienda === parseInt(idTienda));
                    setTienda(tiendaEncontrada);
                }
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const handleInstallClick = () => {
        if (typeof onClose === 'function') {
            onClose();
        }
        window.dispatchEvent(new CustomEvent('open-pwa-install'));
    };

    return (
        <div className='profileContain'>
            {loading ? (
                <div className='loadingBannerFondo'>

                </div>

            ) : (

                <>
                    <div className='fondo'>
                        <img src={tienda?.imagen2} alt="logo" />
                    </div>
                    <div className='profileText'>
                        <img src={tienda?.imagen1} alt="logo" />
                        <h2>{tienda?.nombre}</h2>

                        {tienda?.email && (
                            <Anchor to={`mailto:${tienda.email}`} target="_blank">{tienda.email}</Anchor>
                        )}
                        {tienda?.direccion && (
                            <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">{tienda.direccion}</Anchor>
                        )}

                        <div className='socials'>
                            {tienda?.instagram && (
                                <Anchor to={tienda.instagram} target="_blank" className="socialBtn instagram" title="Instagram"><InstagramIcon /></Anchor>
                            )}
                            {tienda?.tiktok && (
                                <Anchor 
                                    to={tienda.tiktok !== '#' 
                                        ? (tienda.tiktok.startsWith('http') ? tienda.tiktok : `https://tiktok.com/@${tienda.tiktok.replace(/^@/, '')}`) 
                                        : '#'} 
                                    target="_blank" 
                                    className="socialBtn tiktok"
                                    title="TikTok"
                                >
                                    <TikTokIcon />
                                </Anchor>
                            )}
                            {tienda?.telefono && (
                                <Anchor to={`tel:${tienda.telefono}`} target="_blank" className="socialBtn whatsapp" title="WhatsApp"><WhatsAppIcon /></Anchor>
                            )}
                            {tienda?.facebook && (
                                <Anchor to={tienda.facebook} target="_blank" className="socialBtn facebook" title="Facebook"><FacebookIcon /></Anchor>
                            )}
                        </div>

                        <button
                            type="button"
                            className="btnInstallAppProfile"
                            onClick={handleInstallClick}
                            title="Instalar App en tu celular o computadora"
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            <span>Instalar App</span>
                        </button>
                    </div>
                </>
            )}

        </div>
    );
}
